import { hasProducts } from '@core/helpers/video/hasProducts';
import { useContextTranslation } from '@core/i18n';
import { isLiveStream, isLiveStreamLive, isLiveStreamReplay, } from '@core/livestream/helpers';
import { isLiveStreamScheduledInTheFuture } from '@embed/components/common/LiveStreaming/LiveStreamingDateTime/helpers';
import { useGetLiveStreamingDateTime } from '@embed/components/common/LiveStreaming/LiveStreamingDateTime/useGetLiveStreamingDateTime';
/**
 * Custom hook that gets the aria label for a video thumbnail.
 */
export function useThumbnailLabel({ video, index, total, }) {
    const { t } = useContextTranslation();
    const { liveStreamingDate: date, liveStreamingMeridiem: meridiem, liveStreamingTime: time, } = useGetLiveStreamingDateTime({ startAt: video?.started_at });
    const { caption } = video;
    const number = index + 1;
    if (isLiveStream(video)) {
        if (isLiveStreamLive(video)) {
            if (hasProducts(video)) {
                return t(`Video {{number}} of {{total}} - {{caption}} (live now, contains products)`, {
                    number,
                    caption,
                    total,
                });
            }
            return t(`Video {{number}} of {{total}} - {{caption}} (live now)`, {
                number,
                caption,
                total,
            });
        }
        else if (isLiveStreamScheduledInTheFuture(video.started_at)) {
            if (hasProducts(video)) {
                return t(`Video {{number}} of {{total}} - {{caption}} (scheduled for {{date}} at {{time}} {{meridiem}}, contains products)`, {
                    number,
                    caption,
                    date,
                    time,
                    meridiem,
                    total,
                });
            }
            return t(`Video {{number}} of {{total}} - {{caption}} (scheduled for {{date}} at {{time}} {{meridiem}})`, {
                number,
                caption,
                date,
                time,
                meridiem,
                total,
            });
        }
        else if (isLiveStreamReplay(video)) {
            if (hasProducts(video)) {
                return t(`Video {{number}} of {{total}} - {{caption}} (replay, contains products)`, {
                    number,
                    caption,
                    total,
                });
            }
            return t(`Video {{number}} of {{total}} - {{caption}} (replay)`, {
                number,
                caption,
                total,
            });
        }
    }
    else {
        if (hasProducts(video)) {
            return t(`Video {{number}} of {{total}} - {{caption}} (contains products)`, {
                number,
                caption,
                total,
            });
        }
        return t(`Video {{number}} of {{total}} - {{caption}}`, {
            number,
            caption,
            total,
        });
    }
}
